import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { fromEvent, map, of, pairwise, startWith, Subscription } from "rxjs";
import { LoaderService, SignalRService, SecurityService, PortalService } from "./services";
import { NgbModalConfig, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TopNotificationService } from 'src/app/shared/components/top-notification/top-notification.service';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { Helpers } from './helpers';
import { PlatForm } from './models';
import { NavigationStart, Router } from '@angular/router';
import { Constants } from './shared/models/constants';
declare var window: any;
@Component({
    selector: 'medpt-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [NgbModalConfig, NgbModal],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AppComponent implements OnDestroy {
  notification: any;
  isConnected = navigator.onLine;
  loaderStateSubscription: Subscription;
  notificationSubscription: Subscription;
  //routerSubscription: Subscription;
  title = 'TriPort';
  showLoader: Observable<boolean> = of(false);
  loaderText: string = "";
  userLoggedIn: boolean = false;
  favIcon: HTMLLinkElement = <HTMLLinkElement>document.querySelector('#appIcon');
  titleElm: HTMLLinkElement = <HTMLLinkElement>document.querySelector('#appTitle');
  //browserRefresh: boolean = false;
  constructor(
    private loaderService: LoaderService,
    private signalRService: SignalRService,
    private securityService: SecurityService,
    private notificationService: TopNotificationService,
    config: NgbModalConfig,
    ngbModal: NgbModal,
    private router: Router
  ) {

    //this.routerSubscription = router.events.subscribe((event) => {
    //  if (event instanceof NavigationStart) {
    //    if (environment.production) {
    //      this.browserRefresh = !router.navigated;
    //      if (this.browserRefresh) {
    //        this.browserRefresh = false;
    //        if (localStorage.getItem(Constants.LOCALSTORE_USEROBJECT) != null) {
    //          this.securityService.clearLocalStorage();

    //          var returnUrl = window.location.pathname;
    //          if (returnUrl != '/' && returnUrl != '') {
    //            localStorage.setItem(Constants.LOCALSTORE_RETURNURL, window.location.pathname);
    //          }
    //          // not logged in so redirect to login page with the return url
    //          this.securityService.signinRedirect();
    //        }
    //      }
    //    }
    //  }
    //});

    config.backdrop = 'static';
    config.keyboard = false;
    ngbModal.activeInstances.subscribe((value: NgbModalRef[]) => {
      if (value.length > 0)
        this.updateSession();
    });

    window.addEventListener('online', () => {
      this.isConnected = true
    });

    window.addEventListener('offline', () => {
      this.isConnected = false
    });

    this.loaderStateSubscription = this.loaderService
      .getLoaderState()
      .subscribe((state) => {
        setTimeout(() => {
          this.showLoader = of(state.ShowLoader);
          this.loaderText = state.LoadingText == "" ? "Loading" : state.LoadingText;
        });
      });

    this.securityService.getUser().then((user: any) => {
      if (user) {        
        this.signalRService.init();
        this.userLoggedIn = true;
      }
    });

    this.notificationSubscription = this.notificationService
      .getNotification()
      .subscribe((notification) => {
        this.notification = notification;
      });

    this.favIcon.href = Helpers.getPlatformIcon();
    this.titleElm.innerHTML = Helpers.getPlatformName();

    this.media('print').pipe(pairwise()).subscribe(([print, notPrint]) => {
      console.log('print', print, notPrint);
      // check afterprint that refers to the print dialog opened and then closed
      if (print && !notPrint) {
        /* but you code here */
      }
    });
   
  }

  ngAfterViewInit() {
    setInterval(() => { this.scrollFixed(); }, 500);
    window.addEventListener("scroll", this.scrollFixed);
    
    

  }

  ngOnDestroy() {
    this.loaderStateSubscription.unsubscribe();
    this.notificationSubscription.unsubscribe();
    //this.routerSubscription.unsubscribe();
    window.removeEventListener("scroll", this.scrollFixed);
  }

  updateSession() {
    this.securityService.manageUserSession(1);
  }

  private scrollFixed() {
    const grid = <HTMLElement>document.querySelector(".k-grid:not(.nofloating)");
    if (grid != null && grid != undefined) {
      const header = <HTMLElement>grid.querySelector(".k-grid-header");
      if (header != null && header != undefined) {
        const offset = window.scrollY;
        const tableOffsetTop = grid.offsetTop;
        const tableOffsetBottom = tableOffsetTop + grid.clientHeight - header.clientHeight;

        if (offset < tableOffsetTop || offset > tableOffsetBottom) {
          header.classList.remove("fixed-header");
        } else if (offset >= tableOffsetTop && offset <= tableOffsetBottom) {
          header.classList.add("fixed-header");
          if (grid.clientWidth > 0) {
            header.style.width = grid.clientWidth + "px";
          }
        }
      }

    }
  }

  media(query: string): Observable<boolean> {
    const mediaQuery = window.matchMedia(query);
    return fromEvent<MediaQueryList>(mediaQuery, 'change').pipe(
      startWith(mediaQuery),
      map((list: MediaQueryList) => list.matches)
    );
  }
}
